document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) toggle.addEventListener('click', function () {
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });
  if (toggle && nav) document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && nav.classList.contains('is-open')) {
      nav.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); toggle.focus();
    }
  });
  document.querySelectorAll('[data-product-purchase]').forEach(function (container) {
    var select = container.querySelector('select[name="id"]');
    var data = container.querySelector('[data-product-variants]');
    if (!select || !data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    select.addEventListener('change', function () {
      var variant = variants.find(function (item) { return String(item.id) === select.value; });
      if (!variant) return;
      container.querySelector('[data-product-price]').textContent = variant.price;
      var button = container.querySelector('[data-product-submit]');
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.addLabel : button.dataset.soldLabel;
      var quantity = container.querySelector('[name="quantity"]');
      quantity.min = variant.min; quantity.step = variant.step;
      if (variant.max === null) quantity.removeAttribute('max'); else quantity.max = variant.max;
      var value = Math.max(variant.min, Number(quantity.value) || variant.min);
      value = variant.min + Math.ceil((value - variant.min) / variant.step) * variant.step;
      quantity.value = variant.max === null ? value : Math.min(value, variant.max);
    });
  });
});
